var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"to":_vm.to}},[_c('v-card-title',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.subtitle))]),_c('v-card-text',{staticClass:"text-center"},[_c('v-icon',{staticClass:"primary--text",attrs:{"size":"100"}},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }